<script>

export default {
    setup() {

    },
    props: {
        data: Object,
        blockData: Object,
        mission: Object,
        missionIndex: Number,
        missionStatusCode: Number,
        totalMissions: Number,
        userImage: String,
        progress: Number,
        questUsers: Object,
        current: [Number, String],
        mapBasePath: String,
    },
    data() {
        return {
            users: null,
            demoMissionOrder: 1
        }
    },
    methods: {
        getCurrentMissionPercentage() {
            return Math.round(this.progress);
        },
        getQuestUsersForCurrentMission() {
            if (this.questUsers[this.mission.order] !== undefined) {
                this.users = this.questUsers[this.mission.order];
            }
        },
        getProgressPercentage(percentage) {
            const percent = 0;
            return `background: conic-gradient(transparent ${percent}%, transparent ${percent}%)`;
        }
    },
    mounted() {
        this.getQuestUsersForCurrentMission();
        if (this.current === this.mission.order) {
            setTimeout(() => {
                this.$refs.currentMission.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            }, 500);
        }
    }
}
</script>

<template>
    <div
        :class="['mq-map-mission-item', blockData.is_initial ? 'is-initial' : '', missionStatusCode == 203 ? 'is-completed' : '', missionStatusCode == 204 ? 'is-skipped' : '', missionStatusCode == 202 ? 'is-current' : '',  missionStatusCode == 200 ? 'is-locked' : '', missionStatusCode == 201 ? 'is-open' : '']">
        <div class='mq-map-mission-item-progress' v-if='current == mission.order' ref='currentMission'>
            <div style='' class='mq-map-mission-item-progress-block'>
                <div style='position: relative; display: flex; justify-content: center; align-items: center;'>
                    <div class='middle-circle' :style="`background-image: url(${userImage}); background-size: cover;`"
                         v-if='userImage.length > 0'></div>
                    <div class='middle-circle'
                         style='background-image: url(https://mql-dashboard-maps.s3.us-west-2.amazonaws.com/static/icons/avatar.png); background-size: cover;'
                         v-else></div>
                    <div class='progress-spinner' :style='getProgressPercentage(getCurrentMissionPercentage())'></div>
                </div>
            </div>
            <div class='text-xs font-bold py-1 pl-1'>
                {{ $tt('map_page__you_are_here') }}
            </div>
        </div>
        <h4>{{ $tt('map_page__mission') }}: {{ mission.order }}</h4>
        <h5>
            {{ mission.name }}
        </h5>
        <div :class="['mq-map-mission-item-icon', current == mission.order ? 'is-current' : '']">
            <p v-if='current == mission.order'>
                {{ getCurrentMissionPercentage() }}%
            </p>
            <img :src="this.mapBasePath + '/icons/completed_mission.svg'" v-if="missionStatusCode == 203">
            <img :src="mapBasePath + '/icons/skipped_mission.svg'" v-if="missionStatusCode == 204">
            <img :src="mapBasePath + '/icons/active_mission.svg'" v-if="missionStatusCode == 202">
            <img :src="mapBasePath + '/icons/active_mission.svg'" v-if="missionStatusCode == 201">
            <img :src="mapBasePath + '/icons/locked_mission.svg'" v-if="missionStatusCode == 200">
        </div>
        <div class="mq-map-mission-users-list" v-if="users">
            <div v-for="(user, i) in users.slice(0, 5)" v-bind:key="`user-${i}`">
                <span v-if='user.image.length > 0' :style="`background-image: url(${user.image});`"></span>
                <span v-else
                      :style="'background-image: url(' + mapBasePath + '/icons/avatar.png); background-size: cover;'">
				</span>
            </div>
            <p v-if='users.length > 5'>
                +{{ users.slice(5).length }}
            </p>
        </div>
    </div>
</template>

